import { IConnection } from "../model/respone/IConnection";
import { apiGuestClient } from "./apiGuestClient";

export const connectionApi = {
    generate: (payload: IConnection) => apiGuestClient.post(`generate`, payload)
}